import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { MediaOverlay, useMedia } from ".";
export const MediaPreview = ({ media, onSelectMedia, BoxProps, }) => {
    /**
     * We use the first image as preview for the RichMedia
     *
     * Note: this behavior is implemented on the BFF media section
     * but the image returned was not optimized as "medium size"
     */
    const { previewUrl, previewFallBackUrl } = useMedia(media);
    const previewImage = previewUrl !== null && previewUrl !== void 0 ? previewUrl : previewFallBackUrl;
    const aspectRatio = "4 / 3";
    const onClick = () => {
        onSelectMedia(media);
    };
    return (_jsxs(Box, Object.assign({ borderRadius: "radius.16", width: "100%", height: "100%", position: "relative", onClick: onClick }, BoxProps, { children: [_jsx(MediaOverlay, { media: media, onClick: onClick }), previewImage && (_jsx(Box, { as: "img", src: previewImage, borderRadius: "radius.16", cursor: "pointer", objectFit: "cover", unsafe_style: {
                    aspectRatio,
                }, width: "100%", loading: "lazy", onError: (e) => {
                    e.currentTarget.src = previewFallBackUrl;
                } }))] })));
};
